import * as actions from './actions';
import * as selectors from './selectors';
import * as constants from './constants';
import reducer from './reducer';

export default {
  reducer, selectors, actions, constants,
};
